"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";
import { setRememberMe } from "@/lib/auth/session-config";

/**
 * Client component to handle Remember Me setting after login
 * Should be included in login page to process rememberMe parameter
 */
export function LoginHandler() {
  const searchParams = useSearchParams();
  
  useEffect(() => {
    if (!searchParams) return;
    
    // Check if rememberMe parameter is present (from login redirect)
    const rememberMeParam = searchParams.get('rememberMe');
    
    if (rememberMeParam !== null) {
      const shouldRemember = rememberMeParam === 'true';
      setRememberMe(shouldRemember);
    }
  }, [searchParams]);
  
  return null; // This component doesn't render anything
}
